import {
  TDate,
  TNptReasonWithDisplayName,
  TREQUEST_LINES_NPT_DETAILS,
  TREQUEST_NPT_REASONS_LIST,
  TREQUEST_WORKSTATIONS_NPT_DETAILS,
  TREQUEST_WORKSTATION_NPTS,
  TRESPONSE_LINES_NPT_DETAILS,
  TRESPONSE_NPT_REASONS_LIST,
  TRESPONSE_WORKSTATIONS_NPT_DETAILS,
  TRESPONSE_WORKSTATION_NPTS,
} from '@monorepo/types';
import { TUserPaginationOption } from '@monorepo/ui';
import { Action } from '@ngrx/store';
import { TNptActionTypes } from './npt.models';

export class GetNptLinesDetails implements Action {
  readonly type = TNptActionTypes.GetNptLinesDetails;
  constructor(public payload: TREQUEST_LINES_NPT_DETAILS) {}
}
export class GetNptLinesDetailsSuccess implements Action {
  readonly type = TNptActionTypes.GetNptLinesDetailsSuccess;
  constructor(public nptLinesDetails: TRESPONSE_LINES_NPT_DETAILS) {}
}
export class GetNptLinesDetailsFailure implements Action {
  readonly type = TNptActionTypes.GetNptLinesDetailsFailure;
  constructor() {}
}

export class GetNptWorkstationsDetails implements Action {
  readonly type = TNptActionTypes.GetNptWorkstationsDetails;
  constructor(public payload: TREQUEST_WORKSTATIONS_NPT_DETAILS) {}
}
export class GetNptWorkstationsDetailsSuccess implements Action {
  readonly type = TNptActionTypes.GetNptWorkstationsDetailsSuccess;
  constructor(public nptWorkstationGroups: TRESPONSE_WORKSTATIONS_NPT_DETAILS['workstationGroups']) {}
}
export class GetNptWorkstationsDetailsFailure implements Action {
  readonly type = TNptActionTypes.GetNptWorkstationsDetailsFailure;
  constructor() {}
}

export class GetWorkstationsNpts implements Action {
  readonly type = TNptActionTypes.GetWorkstationsNpts;
  constructor(public payload: TREQUEST_WORKSTATION_NPTS) {}
}
export class GetWorkstationsNptsSuccess implements Action {
  readonly type = TNptActionTypes.GetWorkstationsNptsSuccess;
  constructor(public workstationNpts: TRESPONSE_WORKSTATION_NPTS['npts']) {}
}
export class GetWorkstationsNptsFailure implements Action {
  readonly type = TNptActionTypes.GetWorkstationsNptsFailure;
  constructor() {}
}

export class NptSetSelectedDate implements Action {
  readonly type = TNptActionTypes.NptSetSelectedDate;
  constructor(public selectedDate: TDate) {}
}

export class SetNptReasons implements Action {
  readonly type = TNptActionTypes.SetNptReasons;
  constructor(public nptReasons: TNptReasonWithDisplayName[]) {}
}

export class FetchNptReasonsList implements Action {
  readonly type = TNptActionTypes.FetchNptReasonsList;
  constructor(public payload: TREQUEST_NPT_REASONS_LIST, public resetPagination?: boolean) {}
}

export class FetchNptReasonsListSuccess implements Action {
  readonly type = TNptActionTypes.FetchNptReasonsListSuccess;
  constructor(public payload: TRESPONSE_NPT_REASONS_LIST) {}
}

export class FetchNptReasonsListFailure implements Action {
  readonly type = TNptActionTypes.FetchNptReasonsListFailure;
}

export class SetReasonsListPaginationOption implements Action {
  readonly type = TNptActionTypes.SetReasonsListPaginationOption;
  constructor(public payload: TUserPaginationOption) {}
}

export type TNptActions =
  | GetNptLinesDetails
  | GetNptLinesDetailsSuccess
  | GetNptLinesDetailsFailure
  | GetNptWorkstationsDetails
  | GetNptWorkstationsDetailsSuccess
  | GetNptWorkstationsDetailsFailure
  | NptSetSelectedDate
  | SetNptReasons
  | GetWorkstationsNpts
  | GetWorkstationsNptsSuccess
  | GetWorkstationsNptsFailure
  | FetchNptReasonsList
  | FetchNptReasonsListSuccess
  | FetchNptReasonsListFailure
  | SetReasonsListPaginationOption;
